import script from "./AddVisualizationMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AddVisualizationMenu.vue?vue&type=script&setup=true&lang=js"

import "./AddVisualizationMenu.vue?vue&type=style&index=0&id=23617e9a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23617e9a"]])

export default __exports__